(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGOEditor"), require("FEGORender"), require("FEGOWebapi"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGOEditor", "FEGORender", "FEGOWebapi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/common-fission-invite-code/render"] = factory(require("VueDemi"), require("FEGOEditor"), require("FEGORender"), require("FEGOWebapi"));
	else
		root["/fego/component/common-fission-invite-code/render"] = factory(root["VueDemi"], root["FEGOEditor"], root["FEGORender"], root["FEGOWebapi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__4183__, __WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__5113__) => {
return 